<template>
    <body
      data-spy="scroll"
      data-offset="60"
      data-target=".nav__holder"
      data-cookie="on"
      id="PageNotFound"
      itemscope
      itemtype="http://schema.org/WebPage"
    >
        <!-- Google Tag Manager (noscript) -->
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TNTLH4R"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <!-- End Google Tag Manager (noscript) -->
        <main class="main-wrap">
            <div class="content-wrap">
                <div class="error-container">
                    <div class="error-text-container">
                        <h1 class="error-title">Oops, something went wrong...</h1>
                        <h3 class="error-subtext">
                            Error 404: The page you are looking for is unavailable. Do you wish to <router-link to="/">return to the Home Page</router-link>?
                        </h3>
                    </div>
                    <div class="error-image">
                        <img src="../img/broken-kiln.png" alt="Broken Kiln">
                    </div>
                </div>
            </div>
        </main>
    </body>
</template>

<script>
    export default {
        name: "PageNotFound",
        components: {

        }
    };
</script>

<style lang="scss">
    @import '../styles/base/_mixins.scss';

    .error-container {
        background-image: url("../img/waves/Wave3a.svg");
        background-repeat: no-repeat;
        background-position: center top;
        background-size: contain;
        margin-top: 4vw;
        padding-top: 10vw;
        display: flex;
        justify-content: center;
        align-items: center;

        @include breakpoint-below-laptop {
            align-items: center;
        }

        @include breakpoint-large-tablet {
            margin-top: 6rem;
        }

        @include breakpoint-tablet {
            margin-top: 3rem;
        }

        @include breakpoint-mobile {
            flex-direction: column;
            align-items: flex-start;
            margin-top: 3rem;
        }

        @include breakpoint-small-mobile {
            flex-direction: column;
            align-items: flex-start;
            margin-top: 3.8rem;
        }
        
        .error-text-container {
            margin-left: 10vw;
            padding-top: 8vw;

            @include breakpoint-tablet {
                margin-left: 5vw;
            }

            @include breakpoint-small-mobile {
                margin-left: 1rem;
            }

            .error-title {
                @include breakpoint-mobile {
                    width: 80vw;
                }

                @include breakpoint-small-mobile {
                    font-size: 1rem;
                }
            }

            .error-subtext {
                width: 40vw;
                color: #fc8e27;
                margin-top: 3vw;

                @include breakpoint-mobile {
                    width: 80vw;
                }

                @include breakpoint-small-mobile {
                    width: 80vw;
                    font-size: 0.8rem;
                }
            }

            a {
                text-decoration: underline;
            }

            a:hover {
                color: #f2ba5c;
            }
        }

        .error-image {
            padding-top: 8vw;
            margin-left: 5rem;
            margin-right: 10rem;

            @include breakpoint-extra-large {
                margin-left: 20rem;
                margin-right: 10vw;
            }

            @include breakpoint-below-laptop {
                margin-left: 5rem;
                margin-right: 5rem;
            }

            @include breakpoint-tablet {
                margin-left: 2rem;
                margin-right: 2rem;
            }

            @include breakpoint-mobile {
                margin-left: 2rem;
                margin-right: 2rem;
            }

            @include breakpoint-small-mobile {
                margin-left: 0rem;
                margin-right: 0rem;
                width: 100vw;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            
            img {
                margin-top: 1rem;
                width: 25rem;

                @include breakpoint-below-laptop {
                    width: 30rem;
                }

                @include breakpoint-tablet {
                    width: 40rem;
                }

                @include breakpoint-mobile {
                    width: 40rem;
                }

                @include breakpoint-small-mobile {
                    width: 50vw;
                    margin-top: 0rem;
                }
            }
        }
    }
</style>